import { Component, Inject, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ProductService } from '../product.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { CompanysitesService } from '../../company-sites/company-sites.service';
import { ConfigService } from 'src/app/shared/config';

@Component({
  selector: 'product-edit-popup',
  templateUrl: './product-edit-popup.html',
  styleUrls: ['./product-edit-popup.css']
})
export class ProductEditPopup implements OnDestroy {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  productChannelRef$;

  productForm: UntypedFormGroup;
  category: string = '';
  allCategories = [];
  editMode = false;
  id = ""
  product$ = new Subscription();
  base64textString = ""
  isSpecialPrice = false;
  siteId: string;
  @ViewChild('categoryInput', { static: false }) categoryInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;

  missingCategoryWarning = false;

  constructor(
    private configService: ConfigService,
    public dialogRef: MatDialogRef<ProductEditPopup>,
    private productService: ProductService,
    private ng2ImgMax: Ng2ImgMaxService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.editMode = data['pId'] != null;
    this.id = data['pId'];
    this.isSpecialPrice = data['isSpecialPrice'] || false;
    this.siteId = data['siteId'] || '';
    console.log('Product Edit Popup - ID:', this.id, 'Special Price Mode:', this.isSpecialPrice, 'SiteId:', this.siteId);
    this.initForm()
    this.productService.getAllCategories().subscribe((snapshot) => {
      snapshot.forEach((doc) => {
        this.allCategories.push(doc.data()['name'])
      })
    })

    this.initForm();

    this.productService.getAllCategories().subscribe(snapshot => {
      this.allCategories = [];
      snapshot.forEach(doc => {
        const data = doc.data();
        if (data && data['name']) {
          this.allCategories.push(data['name']);
        }
      });
    });

  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  private initForm() {
    let productName = '';
    let imageUrl = "";
    let description = '';
    let price: number = 0;
    // let id = '';
    let productNumber = ''
    let threshold = 0;
    let cost = 0;
    let ILProductName = 0;
    let extractionTime = 0;
    let voltage = 0;
    let type = 'close'
    let barcode = ''
    let maxLimit = 0;
    let vat = 15;
    let minCateringOrder = 3;
    let isHalal: boolean = false;
    let isVegetar: boolean = false;
    let isNew: boolean = false;
    let isNewRecipe: boolean = false;
    let dagensProdukt: boolean = false;
    let isGlutenFri: boolean = false;
    let isLaktoseFri: boolean = false;
    let pant: number = 0;
    let isDisabled: boolean = false;


    this.productForm = new UntypedFormGroup({
      'name': new UntypedFormControl(productName, Validators.required),
      'productNumber': new UntypedFormControl(productNumber, Validators.required),
      'imageUrl': new UntypedFormControl(imageUrl, Validators.required),
      'description': new UntypedFormControl(description, Validators.required),
      'price': new UntypedFormControl(price, Validators.required),
      'id': new UntypedFormControl(this.id),
      'category': new UntypedFormControl('', Validators.required),
      'ILProductName': new UntypedFormControl(ILProductName),
      'barcode': new UntypedFormControl(barcode),
      // 'type': new UntypedFormControl(type, Validators.required),
      'threshold': new UntypedFormControl(threshold, Validators.required),
      // Days this product keeps in a machine. Overrides the category's
      // maxLife in the driver app's svinn suggestions; empty = use category.
      'shelfLifeDays': new UntypedFormControl(null),
      'cost': new UntypedFormControl(cost),
      'maxLimit': new UntypedFormControl(maxLimit, Validators.required),
      'vat': new UntypedFormControl(vat, Validators.required),
      'minCateringOrder': new UntypedFormControl(minCateringOrder),
      'isHalal': new UntypedFormControl(isHalal),
      'isVegetar': new UntypedFormControl(isVegetar),
      'isNewRecipe': new UntypedFormControl(isNewRecipe),
      'isGlutenFri': new UntypedFormControl(isGlutenFri),
      'isLaktoseFri': new UntypedFormControl(isLaktoseFri),
      'pant': new UntypedFormControl(pant),
      'isNew': new UntypedFormControl(isNew),
      // 'extractionTime': new UntypedFormControl(extractionTime),
      // 'voltage': new UntypedFormControl(voltage),
      'dagensProdukt': new UntypedFormControl(dagensProdukt),
      'isDisabled': new UntypedFormControl(isDisabled),
      'allergens': new UntypedFormControl(''),
      'nutritionEnergyKj': new UntypedFormControl(null),
      'nutritionEnergyKcal': new UntypedFormControl(null),
      'nutritionFat': new UntypedFormControl(null),
      'nutritionSaturatedFat': new UntypedFormControl(null),
      'nutritionCarbs': new UntypedFormControl(null),
      'nutritionSugar': new UntypedFormControl(null),
      'nutritionProtein': new UntypedFormControl(null),
      'nutritionSalt': new UntypedFormControl(null),
    })

    if (this.editMode) {
      this.missingCategoryWarning = false;
      this.product$ = this.productService.getProductById$(this.id).pipe(tap(obj => {
        let selectedCategory = (Array.isArray(obj['categories']) ? obj['categories'][0] : '');
        if (!selectedCategory) {
          this.missingCategoryWarning = true;
        }
        this.productForm.patchValue({
          name: obj['name'],
          productNumber: obj['productNumber'],
          imageUrl: obj['imageUrl'],
          description: obj['description'],
          price: obj['price'],
          category: selectedCategory,
          id: obj['id'],
          type: obj['type'],
          barcode: obj['barcode'] ? obj['barcode'] : null,
          threshold: obj['threshold'],
          shelfLifeDays: obj['shelfLifeDays'] ?? null,
          cost: obj['cost'] ? obj['cost'] : 0,
          ILProductName: obj['ILProductName'] ? obj['ILProductName'] : "",
          // extractionTime: obj['extractionTime']? obj['extractionTime']: 0,
          // voltage: obj['voltage']? obj['voltage'] :0,
          maxLimit: obj['maxLimit'],
          vat: obj['vat'],
          minCateringOrder: obj['minCateringOrder'] ? obj['minCateringOrder'] : 3,
          pant: obj['pant'] ? obj['pant'] : 0,
          isHalal: obj['isHalal'] ? obj['isHalal'] : false,
          isNewRecipe: obj['isNewRecipe'] ? obj['isNewRecipe'] : false,
          isVegetar: obj['isVegetar'] ? obj['isVegetar'] : false,
          isNew: obj['isNew'] ? obj['isNew'] : false,
          isGlutenFri: obj['isGlutenFri'] ? obj['isGlutenFri'] : false,
          isLaktoseFri: obj['isLaktoseFri'] ? obj['isLaktoseFri'] : false,
          dagensProdukt: obj['dagensProdukt'] ? obj['dagensProdukt'] : false,
          isDisabled: obj['isDisabled'] ? obj['isDisabled'] : false,
          allergens: obj['allergens'] || '',
          nutritionEnergyKj: obj['nutritionEnergyKj'] ?? null,
          nutritionEnergyKcal: obj['nutritionEnergyKcal'] ?? null,
          nutritionFat: obj['nutritionFat'] ?? null,
          nutritionSaturatedFat: obj['nutritionSaturatedFat'] ?? null,
          nutritionCarbs: obj['nutritionCarbs'] ?? null,
          nutritionSugar: obj['nutritionSugar'] ?? null,
          nutritionProtein: obj['nutritionProtein'] ?? null,
          nutritionSalt: obj['nutritionSalt'] ?? null,
        })
        this.allCategories = obj['categories']

        // If in special price mode, load the current special price
        if (this.isSpecialPrice && this.siteId) {
          this.loadSpecialPrice();
        }

        this.category = selectedCategory;


      })).subscribe()
      this.productChannelRef$ = this.productService.getProductChannelRefById$(this.id)
    }

    // Disable all fields except price
    if (this.isSpecialPrice) {
      Object.keys(this.productForm.controls).forEach(key => {
        if (key !== 'price') {
          this.productForm.get(key)?.disable();
        }
      });
    }

  }


  onImageChange(event) {
    let image = event.target.files[0];

    this.ng2ImgMax.resizeImage(image, 400, 400).subscribe(
      result => {
        console.log(result)
        let reader = new File([result], result.name);
        this.getImagePreview(reader);
      },
      error => {
        console.log('😢 Oh no!', error);
      }
    );
  }

  getImagePreview(file: File) {
    const reader: FileReader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);

    reader.readAsBinaryString(file);

  }
  _handleReaderLoaded(readerEvt) {
    let binaryString = readerEvt.target.result;

    this.base64textString = "data:image/png;base64," + btoa(binaryString);
    // console.log(this.base64textString)
    this.productForm.value.imageUrl = this.base64textString

    this.productForm.patchValue({ imageUrl: this.productForm.value.imageUrl });
  }

  async onSubmit() {
    if (this.isSpecialPrice) {
      const specialPriceData = {
        companyId: this.configService.getCompanyId(),
        siteId: this.siteId,
        productId: this.id,
        price: this.productForm.get('price')?.value
      };

      console.log('Saving special price:', specialPriceData);

      try {
        const result = await this.productService.saveSpecialPrice(specialPriceData);
        if (result) {
          console.log('Special price saved successfully');
          this.dialogRef.close({ specialPriceSaved: true, productId: this.id });
        }
      } catch (error) {
        console.error('Error saving special price:', error);
      }
    } else {
      // single-category selection and save as a single-value array
      const formValue = { ...this.productForm.value };
      const selectedCategory = formValue.category;
      delete formValue.category;
      formValue.categories = [selectedCategory];


      if (this.editMode) {
        let result = this.productService.updateProduct(this.id, formValue);
        if (result)
          this.dialogRef.close({ updated: true});
      } else {
        let checkDuplicate = await this.productService.checkDuplicate(formValue)
        if (checkDuplicate) {
          let result = this.productService.addProduct(formValue);
          if (result)
            this.dialogRef.close({ updated: true });
        } else {
          let checkDuplicate = await this.productService.checkDuplicate(this.productForm.value)
          if (checkDuplicate) {
            let result = this.productService.addProduct(this.productForm.value);
            if (result)
              this.dialogRef.close({ updated: true });
          }
        }
      }
    }
  }


  // Load current special price for this product and system
  private loadSpecialPrice(): void {
    this.productService.getSpecialPrices(this.configService.getCompanyId(), this.siteId).subscribe(
      specialPrices => {
        const currentSpecialPrice = specialPrices.find(sp => sp.productId === this.id);
        if (currentSpecialPrice) {
          console.log('Found special price:', currentSpecialPrice.price, 'for product:', this.id);
          this.productForm.patchValue({
            price: currentSpecialPrice.price
          });
        }
      },
      error => {
        console.error('Error loading special price:', error);
      }
    );

  }

  linkMaker(obj) {
    this.configService.changeCompanyId(obj.companyId, false)
    return `/dashboard/sites/${obj.siteId}/system/${obj.systemId}/vmmachine/${obj.machineId}`;
  }

  removeRefrence(obj) {
    console.log(obj)
    this.productService.removeProductChannelRefById(obj.ref);
  }
  ngOnDestroy() {
    if (this.product$)
      this.product$.unsubscribe()
    console.log("Popup Destoryed");
  }
}
